import { StateNode } from '@ansys-internal/awf-angular/store';

export class SelectedComponentState implements StateNode<string[]> {
  key: string = 'selectedComponent';
  mutable: boolean = true;
  observeInitial: boolean = true;
  defaultValue: () => string[] = () => [];
}
